import type { ModelSpec } from '../shapes';

export const HOME: ModelSpec[] = [
  {
    id: 'chair3d',
    label: 'Chair',
    group: 'Home',
    parts: { seat: 'seat', back: 'back', leg: 'leg', cushion: 'cushion', armrest: 'armrest', coat: 'coat', bag: 'bag' },
    shapes: [
      { part: 'seat', k: 'box', s: [1.6, 0.12, 1.5], p: [0, 1.0, 0], c: '#a87a4f' },
      { part: 'leg', k: 'box', s: [0.14, 0.94, 0.14], p: [0.7, 0.47, 0.64], c: '#7a5434', mx: true, mz: true },
      { part: 'back', k: 'box', s: [0.14, 1.5, 0.14], p: [0.7, 1.8, -0.64], c: '#7a5434', mx: true },
      { part: 'back', k: 'box', s: [1.3, 1.1, 0.08], p: [0, 1.95, -0.64], c: '#a87a4f' },
      { part: 'cushion', k: 'rbox', s: [1.35, 0.16, 1.25, 0.06], p: [0, 1.14, 0.03], c: '#7f9c7a', f: 'soft' },
      { part: 'armrest', k: 'box', s: [0.14, 0.1, 1.2], p: [0.78, 1.55, -0.02], c: '#7a5434', mx: true },
      { part: 'armrest', k: 'tube', s: [0.06], p: [0.78, 1.06, 0.5], to: [0.78, 1.52, 0.5], c: '#7a5434', mx: true },
      { part: 'coat', k: 'rbox', s: [1.2, 1.0, 0.1, 0.04], p: [0, 2.05, -0.75], c: '#3e5a7a', f: 'soft' },
      { part: 'coat', k: 'rbox', s: [1.2, 0.12, 0.3, 0.04], p: [0, 2.6, -0.66], c: '#3e5a7a', f: 'soft' },
      { part: 'coat', k: 'rbox', s: [0.3, 0.8, 0.1, 0.04], p: [0.45, 1.35, -0.78], r: [0, 0, 6], c: '#3e5a7a', f: 'soft', mx: true },
      { part: 'bag', k: 'rbox', s: [0.6, 0.5, 0.25, 0.08], p: [0, 1.1, -0.95], c: '#c0563f', f: 'matte' },
      { part: 'bag', k: 'tube', s: [0.03], p: [-0.2, 1.33, -0.92], to: [-0.12, 2.0, -0.82], c: '#7a3a2a' },
      { part: 'bag', k: 'tube', s: [0.03], p: [0.2, 1.33, -0.92], to: [0.12, 2.0, -0.82], c: '#7a3a2a' },
    ],
  },
  {
    id: 'table3d',
    label: 'Table',
    group: 'Home',
    parts: { cloth: 'cloth', plate: 'plate', cup: 'cup', fork: 'fork', leg: 'leg', drawer: 'drawer', chair: 'chair' },
    shapes: [
      { part: 'top', k: 'box', s: [2.6, 0.1, 1.6], p: [0, 1.2, 0], c: '#9a6b43' },
      { part: 'top', k: 'box', s: [2.4, 0.28, 1.4], p: [0, 1.01, 0], c: '#8a5d38' },
      { part: 'leg', k: 'box', s: [0.16, 1.15, 0.16], p: [1.15, 0.575, 0.65], c: '#6e4a2c', mx: true, mz: true },
      { part: 'cloth', k: 'box', s: [2.72, 0.04, 1.72], p: [0, 1.27, 0], c: '#e7eef4', f: 'soft' },
      { part: 'cloth', k: 'box', s: [2.72, 0.18, 0.03], p: [0, 1.18, 0.86], c: '#e7eef4', f: 'soft' },
      { part: 'cloth', k: 'box', s: [0.03, 0.18, 1.72], p: [1.36, 1.18, 0], c: '#e7eef4', f: 'soft', mx: true },
      { part: 'cloth', k: 'box', s: [2.72, 0.06, 0.12], p: [0, 1.3, 0.55], c: '#6f9cc4', f: 'soft' },
      { part: 'cloth', k: 'box', s: [2.72, 0.06, 0.12], p: [0, 1.3, -0.55], c: '#6f9cc4', f: 'soft' },
      { part: 'plate', k: 'cyl', s: [0.42, 0.32, 0.06], p: [0.1, 1.32, 0.2], c: '#fdfcf8', f: 'shiny' },
      { part: 'plate', k: 'cyl', s: [0.3, 0.3, 0.02], p: [0.1, 1.355, 0.2], c: '#e3c79a' },
      { part: 'food', k: 'sphere', s: [0.13], p: [0.15, 1.38, 0.2], sc: [1, 0.6, 1], c: '#e07a4a' },
      { part: 'food', k: 'sphere', s: [0.1], p: [0.0, 1.38, 0.28], sc: [1, 0.6, 1], c: '#7aa65a' },
      { part: 'cup', k: 'cyl', s: [0.17, 0.14, 0.32], p: [-0.75, 1.45, 0.25], c: '#d98a5a', f: 'shiny' },
      { part: 'cup', k: 'torus', s: [0.1, 0.035], p: [-0.95, 1.46, 0.25], c: '#d98a5a', f: 'shiny' },
      { part: 'fork', k: 'box', s: [0.1, 0.03, 0.45], p: [0.75, 1.305, 0.3], c: '#8f959c', f: 'metal' },
      { part: 'fork', k: 'box', s: [0.22, 0.03, 0.1], p: [0.75, 1.305, 0.02], c: '#8f959c', f: 'metal' },
      { part: 'fork', k: 'box', s: [0.04, 0.03, 0.2], p: [0.67, 1.305, -0.1], c: '#8f959c', f: 'metal' },
      { part: 'fork', k: 'box', s: [0.04, 0.03, 0.2], p: [0.75, 1.305, -0.1], c: '#8f959c', f: 'metal' },
      { part: 'fork', k: 'box', s: [0.04, 0.03, 0.2], p: [0.83, 1.305, -0.1], c: '#8f959c', f: 'metal' },
      { part: 'drawer', k: 'box', s: [0.8, 0.2, 0.04], p: [0, 0.98, -0.72], c: '#b88a5c' },
      { part: 'drawer', k: 'sphere', s: [0.07], p: [0, 0.98, -0.77], c: '#e1b542', f: 'metal' },
      { part: 'chair', k: 'box', s: [1.0, 0.1, 0.9], p: [0, 0.75, -1.4], c: '#5f7f9a' },
      { part: 'chair', k: 'box', s: [0.1, 0.75, 0.1], p: [0.42, 0.375, -1.02], c: '#4a657c', mx: true },
      { part: 'chair', k: 'box', s: [0.1, 1.85, 0.1], p: [0.42, 0.925, -1.8], c: '#4a657c', mx: true },
      { part: 'chair', k: 'box', s: [0.9, 0.5, 0.08], p: [0, 1.6, -1.8], c: '#5f7f9a' },
    ],
  },
  {
    id: 'bed3d',
    label: 'Bed',
    group: 'Home',
    parts: { headboard: 'headboard', pillow: 'pillow', duvet: 'duvet', mattress: 'mattress', leg: 'leg', drawer: 'drawer', slippers: 'slippers' },
    shapes: [
      { part: 'frame', k: 'box', s: [3.2, 0.32, 1.8], p: [0, 0.44, 0], c: '#9a6b43' },
      { part: 'leg', k: 'cyl', s: [0.1, 0.09, 0.3], p: [1.45, 0.15, 0.78], c: '#6e4a2c', mx: true, mz: true },
      { part: 'drawer', k: 'box', s: [1.1, 0.22, 0.05], p: [0.5, 0.44, -0.92], c: '#c49a6c' },
      { part: 'drawer', k: 'box', s: [0.3, 0.07, 0.06], p: [0.5, 0.44, -0.96], c: '#5a3e26' },
      { part: 'mattress', k: 'rbox', s: [3.1, 0.3, 1.74, 0.08], p: [0, 0.75, 0], c: '#f3efe6', f: 'soft' },
      { part: 'duvet', k: 'rbox', s: [2.1, 0.14, 1.84, 0.06], p: [0.52, 0.95, 0], c: '#5f86b0', f: 'soft' },
      { part: 'duvet', k: 'rbox', s: [2.1, 0.32, 0.06, 0.03], p: [0.52, 0.78, 0.92], c: '#5f86b0', f: 'soft', mz: true },
      { part: 'pillow', k: 'rbox', s: [0.6, 0.24, 1.4, 0.1], p: [-1.15, 1.02, 0], c: '#f2d98c', f: 'soft' },
      { part: 'headboard', k: 'rbox', s: [0.14, 1.75, 1.9, 0.05], p: [-1.65, 0.875, 0], c: '#7a5434' },
      { part: 'frame', k: 'box', s: [0.12, 0.85, 1.85], p: [1.62, 0.6, 0], c: '#7a5434' },
      { part: 'slippers', k: 'rbox', s: [0.2, 0.12, 0.42, 0.05], p: [0.2, 0.06, -1.3], c: '#d77a8a', f: 'soft' },
      { part: 'slippers', k: 'rbox', s: [0.2, 0.12, 0.42, 0.05], p: [0.48, 0.06, -1.25], r: [0, -12, 0], c: '#d77a8a', f: 'soft' },
    ],
  },
  {
    id: 'sofa3d',
    label: 'Sofa',
    group: 'Home',
    parts: { seat: 'seat', back: 'back', arm: 'arm', cushion: 'cushion', leg: 'leg', blanket: 'blanket', pocket: 'pocket' },
    shapes: [
      { part: 'base', k: 'rbox', s: [2.7, 0.42, 1.3, 0.06], p: [0, 0.46, 0], c: '#5d7d88', f: 'soft' },
      { part: 'seat', k: 'rbox', s: [1.25, 0.26, 1.05, 0.08], p: [0.64, 0.8, 0.1], c: '#7598a3', f: 'soft', mx: true },
      { part: 'back', k: 'rbox', s: [2.6, 1.0, 0.32, 0.1], p: [0, 1.15, -0.5], c: '#5d7d88', f: 'soft' },
      { part: 'arm', k: 'rbox', s: [0.32, 0.9, 1.3, 0.1], p: [1.47, 0.7, 0], c: '#4c6a74', f: 'soft', mx: true },
      { part: 'leg', k: 'cyl', s: [0.08, 0.06, 0.26], p: [1.45, 0.13, 0.52], c: '#4a3324', mx: true, mz: true },
      { part: 'cushion', k: 'rbox', s: [0.55, 0.5, 0.16, 0.08], p: [0.85, 1.18, -0.24], r: [-12, 0, 0], c: '#d9a441', f: 'soft', mx: true },
      { part: 'blanket', k: 'rbox', s: [1.0, 0.06, 0.4, 0.03], p: [-0.5, 1.67, -0.5], c: '#c86b4e', f: 'soft' },
      { part: 'blanket', k: 'rbox', s: [1.0, 1.0, 0.06, 0.03], p: [-0.5, 1.17, -0.7], c: '#c86b4e', f: 'soft' },
      { part: 'pocket', k: 'rbox', s: [0.06, 0.5, 0.6, 0.03], p: [-1.66, 0.75, 0.05], c: '#a3825a', f: 'matte' },
      { part: 'pocket', k: 'rbox', s: [0.06, 0.12, 0.22, 0.03], p: [-1.71, 1.02, 0.1], c: '#2f2f33' },
    ],
  },
  {
    id: 'lamp3d',
    label: 'Lamp',
    group: 'Home',
    parts: { shade: 'shade', bulb: 'bulb', pole: 'pole', base: 'base', switch: 'switch', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'base', k: 'cyl', s: [0.6, 0.7, 0.2], p: [0, 0.1, 0], c: '#6b4a32' },
      { part: 'pole', k: 'cyl', s: [0.08, 0.08, 1.5], p: [0, 0.95, 0], c: '#b8955a', f: 'metal' },
      { part: 'pole', k: 'cyl', s: [0.12, 0.12, 0.18], p: [0, 1.7, 0], c: '#b8955a', f: 'metal' },
      { part: 'pole', k: 'tube', s: [0.03], p: [0.1, 1.7, 0], to: [0.42, 2.36, 0], c: '#b8955a', f: 'metal', mx: true },
      { part: 'bulb', k: 'sphere', s: [0.26], p: [0, 1.98, 0], c: '#ffd36b', f: 'glow' },
      { part: 'shade', k: 'cyl', s: [0.45, 0.75, 0.8], p: [0, 2.74, 0], c: '#efe3c8', f: 'soft' },
      { part: 'wire', k: 'tube', s: [0.06], p: [0, 0.07, -0.6], to: [0, 0.06, -1.4], c: '#3a3a3a' },
      { part: 'wire', k: 'tube', s: [0.06], p: [0, 0.06, -1.4], to: [0.6, 0.06, -1.8], c: '#3a3a3a' },
      { part: 'switch', k: 'rbox', s: [0.36, 0.2, 0.55, 0.07], p: [0, 0.1, -1.05], c: '#f4f1ea' },
      { part: 'switch', k: 'box', s: [0.16, 0.08, 0.2], p: [0, 0.22, -1.05], c: '#c8524a' },
      { part: 'plug', k: 'rbox', s: [0.55, 0.42, 0.38, 0.06], p: [0.75, 0.21, -1.95], r: [0, -37, 0], c: '#e8e4dc' },
      { part: 'plug', k: 'box', s: [0.07, 0.16, 0.25], p: [0.93, 0.16, -2.2], r: [0, -37, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'clock3d',
    label: 'Alarm clock',
    group: 'Home',
    parts: { face: 'face', hands: 'hands', bell: 'bell', hammer: 'hammer', leg: 'leg', key: 'key', knob: 'knob' },
    shapes: [
      { part: 'body', k: 'cyl', s: [1.0, 1.0, 0.6], p: [0, 1.3, 0], r: [90, 0, 0], c: '#c8524a', f: 'shiny' },
      { part: 'body', k: 'torus', s: [0.95, 0.07], p: [0, 1.3, 0.31], c: '#d8c48a', f: 'metal' },
      { part: 'face', k: 'disc', s: [0.9], p: [0, 1.3, 0.305], c: '#fbf7ec' },
      { part: 'face', k: 'box', s: [0.06, 0.16, 0.02], p: [0, 2.05, 0.32], c: '#3a3a3a' },
      { part: 'face', k: 'box', s: [0.06, 0.16, 0.02], p: [0, 0.55, 0.32], c: '#3a3a3a' },
      { part: 'face', k: 'box', s: [0.16, 0.06, 0.02], p: [0.75, 1.3, 0.32], c: '#3a3a3a', mx: true },
      { part: 'face', k: 'box', s: [0.05, 0.12, 0.02], p: [0.375, 1.95, 0.32], r: [0, 0, -30], c: '#3a3a3a', mx: true },
      { part: 'face', k: 'box', s: [0.05, 0.12, 0.02], p: [0.65, 1.675, 0.32], r: [0, 0, -60], c: '#3a3a3a', mx: true },
      { part: 'face', k: 'box', s: [0.05, 0.12, 0.02], p: [0.65, 0.925, 0.32], r: [0, 0, 60], c: '#3a3a3a', mx: true },
      { part: 'face', k: 'box', s: [0.05, 0.12, 0.02], p: [0.375, 0.65, 0.32], r: [0, 0, 30], c: '#3a3a3a', mx: true },
      { part: 'hands', k: 'box', s: [0.08, 0.62, 0.03], p: [0.14, 1.57, 0.34], r: [0, 0, -30], c: '#2a2a2a' },
      { part: 'hands', k: 'box', s: [0.1, 0.42, 0.03], p: [-0.18, 1.4, 0.36], r: [0, 0, 60], c: '#2a2a2a' },
      { part: 'hands', k: 'cyl', s: [0.07, 0.07, 0.08], p: [0, 1.3, 0.36], r: [90, 0, 0], c: '#2a2a2a' },
      { part: 'bell', k: 'dome', s: [0.38], p: [0.55, 2.2, 0], r: [0, 0, -32], c: '#c9ccd0', f: 'metal', mx: true },
      { part: 'hammer', k: 'tube', s: [0.05], p: [0, 2.28, 0], to: [0, 2.6, 0], c: '#6a6a6a', f: 'metal' },
      { part: 'hammer', k: 'sphere', s: [0.12], p: [0, 2.66, 0], c: '#3a3a3a', f: 'metal' },
      { part: 'leg', k: 'tube', s: [0.06], p: [0.45, 0.55, 0], to: [0.75, 0.08, 0], c: '#c9ccd0', f: 'metal', mx: true },
      { part: 'leg', k: 'sphere', s: [0.1], p: [0.75, 0.08, 0], c: '#c9ccd0', f: 'metal', mx: true },
      { part: 'key', k: 'cyl', s: [0.06, 0.06, 0.3], p: [0.3, 1.35, -0.42], r: [90, 0, 0], c: '#c9a24a', f: 'metal' },
      { part: 'key', k: 'rbox', s: [0.5, 0.3, 0.06, 0.04], p: [0.3, 1.35, -0.58], c: '#c9a24a', f: 'metal' },
      { part: 'knob', k: 'cyl', s: [0.16, 0.16, 0.14], p: [-0.4, 0.95, -0.36], r: [90, 0, 0], c: '#3a3a3a' },
    ],
  },
  {
    id: 'kettle3d',
    label: 'Kettle',
    group: 'Home',
    parts: { lid: 'lid', spout: 'spout', handle: 'handle', button: 'button', base: 'base', window: 'window', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'base', k: 'cyl', s: [1.1, 1.15, 0.16], p: [0, 0.08, 0], c: '#3a3d42' },
      { part: 'body', k: 'cyl', s: [0.8, 1.0, 1.6], p: [0, 0.96, 0], c: '#e9e4da', f: 'shiny' },
      { part: 'lid', k: 'dome', s: [0.7], p: [0, 1.76, 0], sc: [1, 0.35, 1], c: '#9fb8a8', f: 'shiny' },
      { part: 'lid', k: 'sphere', s: [0.15], p: [0, 2.0, 0], c: '#5f7f6e' },
      { part: 'spout', k: 'cyl', s: [0.12, 0.25, 0.75], p: [0.99, 1.44, 0], r: [0, 0, -50], c: '#9fb8a8', f: 'shiny' },
      { part: 'handle', k: 'tube', s: [0.11], p: [-0.7, 1.6, 0], to: [-1.3, 1.6, 0], c: '#5f7f6e' },
      { part: 'handle', k: 'tube', s: [0.11], p: [-1.3, 1.6, 0], to: [-1.3, 0.55, 0], c: '#5f7f6e' },
      { part: 'handle', k: 'tube', s: [0.11], p: [-1.3, 0.55, 0], to: [-0.9, 0.55, 0], c: '#5f7f6e' },
      { part: 'handle', k: 'sphere', s: [0.11], p: [-1.3, 1.6, 0], c: '#5f7f6e' },
      { part: 'handle', k: 'sphere', s: [0.11], p: [-1.3, 0.55, 0], c: '#5f7f6e' },
      { part: 'button', k: 'rbox', s: [0.3, 0.14, 0.22, 0.05], p: [-1.15, 1.74, 0], c: '#d8574a' },
      { part: 'window', k: 'rbox', s: [0.36, 0.9, 0.1, 0.04], p: [0, 0.95, -0.93], r: [7, 0, 0], c: '#6fa8d8', f: 'glass' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0, 0.06, -1.1], to: [0, 0.05, -1.9], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0, 0.05, -1.9], to: [-0.6, 0.05, -2.3], c: '#2a2a2a' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [-0.74, 0.16, -2.4], r: [0, 37, 0], c: '#e8e4dc' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [-0.9, 0.12, -2.6], r: [0, 37, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'teapot3d',
    label: 'Teapot',
    group: 'Home',
    parts: { lid: 'lid', knob: 'knob', spout: 'spout', handle: 'handle', tray: 'tray', cup: 'cup', tag: 'tag' },
    shapes: [
      { part: 'tray', k: 'cyl', s: [1.65, 1.6, 0.14], p: [0, 0.07, 0], c: '#a87a4f' },
      { part: 'body', k: 'sphere', s: [1.0], p: [0, 0.94, 0], sc: [1, 0.8, 1], c: '#4f8fa0', f: 'shiny' },
      { part: 'lid', k: 'dome', s: [0.58], p: [0, 1.66, 0], sc: [1, 0.45, 1], c: '#f1e6d0', f: 'shiny' },
      { part: 'knob', k: 'sphere', s: [0.16], p: [0, 2.0, 0], c: '#c8524a', f: 'shiny' },
      { part: 'spout', k: 'cyl', s: [0.11, 0.24, 1.0], p: [1.15, 1.15, 0], r: [0, 0, -50], c: '#2f6573', f: 'shiny' },
      { part: 'handle', k: 'torus', s: [0.42, 0.09, 260], p: [-1.0, 1.0, 0], r: [0, 0, 50], c: '#2f6573', f: 'shiny' },
      { part: 'cup', k: 'cyl', s: [0.27, 0.2, 0.36], p: [0.55, 0.32, -1.12], c: '#f1e6d0', f: 'shiny' },
      { part: 'cup', k: 'torus', s: [0.12, 0.035], p: [0.86, 0.33, -1.12], c: '#f1e6d0', f: 'shiny' },
      { part: 'tag', k: 'tube', s: [0.02], p: [-0.25, 1.68, -0.45], to: [-0.35, 1.08, -0.95], c: '#f4f1ea' },
      { part: 'tag', k: 'rbox', s: [0.3, 0.34, 0.05, 0.02], p: [-0.35, 0.92, -1.0], r: [-15, 0, 0], c: '#e8c24a' },
    ],
  },
  {
    id: 'toaster3d',
    label: 'Toaster',
    group: 'Home',
    parts: { toast: 'toast', slot: 'slot', lever: 'lever', dial: 'dial', tray: 'crumb tray', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'body', k: 'rbox', s: [2.2, 1.4, 1.2, 0.2], p: [0, 0.82, 0], c: '#e3d5bb', f: 'shiny' },
      { part: 'body', k: 'box', s: [0.25, 0.12, 0.25], p: [0.85, 0.06, 0.4], c: '#3a3a3a', mx: true, mz: true },
      { part: 'slot', k: 'box', s: [1.7, 0.04, 0.22], p: [0, 1.51, 0.25], c: '#3a3a3a', mz: true },
      { part: 'toast', k: 'rbox', s: [1.3, 0.75, 0.14, 0.12], p: [0, 1.7, 0.25], c: '#d9a45a', f: 'matte', mz: true },
      { part: 'toast', k: 'rbox', s: [1.18, 0.62, 0.16, 0.1], p: [0, 1.72, 0.25], c: '#eccb8a', f: 'matte', mz: true },
      { part: 'lever', k: 'box', s: [0.12, 0.7, 0.04], p: [0.7, 0.95, 0.605], c: '#bfb29a' },
      { part: 'lever', k: 'rbox', s: [0.34, 0.14, 0.26, 0.05], p: [0.7, 1.1, 0.7], c: '#3a3a3a' },
      { part: 'dial', k: 'cyl', s: [0.18, 0.18, 0.12], p: [-0.6, 0.75, 0.64], r: [90, 0, 0], c: '#5a7f9a' },
      { part: 'dial', k: 'box', s: [0.04, 0.16, 0.04], p: [-0.6, 0.8, 0.71], c: '#f4f1ea' },
      { part: 'tray', k: 'box', s: [1.6, 0.2, 0.06], p: [0, 0.28, -0.62], c: '#7a7d82', f: 'metal' },
      { part: 'tray', k: 'box', s: [0.4, 0.08, 0.1], p: [0, 0.28, -0.68], c: '#3a3a3a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [-0.7, 0.4, -0.6], to: [-0.7, 0.05, -1.2], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [-0.7, 0.05, -1.2], to: [-1.2, 0.05, -1.6], c: '#2a2a2a' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [-1.34, 0.16, -1.72], r: [0, 40, 0], c: '#f4f1ea' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [-1.5, 0.12, -1.9], r: [0, 40, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'washer3d',
    label: 'Washing machine',
    group: 'Home',
    parts: { door: 'door', window: 'window', drawer: 'drawer', dial: 'dial', button: 'button', hose: 'hose', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'body', k: 'rbox', s: [2.0, 2.4, 1.8, 0.08], p: [0, 1.28, 0], c: '#eef0f1' },
      { part: 'body', k: 'box', s: [0.2, 0.1, 0.2], p: [0.8, 0.05, 0.7], c: '#5a5a5a', mx: true, mz: true },
      { part: 'body', k: 'box', s: [2.0, 0.02, 0.02], p: [0, 1.85, 0.905], c: '#b9bec2' },
      { part: 'door', k: 'torus', s: [0.62, 0.12], p: [0, 1.0, 0.92], c: '#9aa3ab', f: 'metal' },
      { part: 'door', k: 'box', s: [0.14, 0.34, 0.1], p: [0.74, 1.0, 0.95], c: '#7d868e' },
      { part: 'window', k: 'disc', s: [0.56], p: [0, 1.0, 0.94], c: '#4d7ea8', f: 'glass' },
      { part: 'drawer', k: 'box', s: [0.7, 0.32, 0.06], p: [-0.55, 2.12, 0.92], c: '#d9dde0' },
      { part: 'drawer', k: 'box', s: [0.4, 0.08, 0.06], p: [-0.55, 2.04, 0.96], c: '#7d868e' },
      { part: 'dial', k: 'cyl', s: [0.22, 0.22, 0.12], p: [0.6, 2.12, 0.94], r: [90, 0, 0], c: '#7d868e', f: 'metal' },
      { part: 'dial', k: 'box', s: [0.05, 0.2, 0.04], p: [0.6, 2.18, 1.01], c: '#f4f1ea' },
      { part: 'button', k: 'rbox', s: [0.16, 0.14, 0.06, 0.03], p: [0.1, 2.12, 0.92], c: '#5a9a6a' },
      { part: 'button', k: 'rbox', s: [0.16, 0.14, 0.06, 0.03], p: [0.28, 2.12, 0.92], c: '#d8574a' },
      { part: 'hose', k: 'tube', s: [0.08], p: [0.45, 0.6, -0.9], to: [0.45, 0.6, -1.25], c: '#8a8f94' },
      { part: 'hose', k: 'tube', s: [0.08], p: [0.45, 0.6, -1.25], to: [0.45, 2.3, -1.25], c: '#8a8f94' },
      { part: 'hose', k: 'tube', s: [0.08], p: [0.45, 2.3, -1.25], to: [0.45, 2.6, -1.0], c: '#8a8f94' },
      { part: 'hose', k: 'sphere', s: [0.08], p: [0.45, 0.6, -1.25], c: '#8a8f94' },
      { part: 'hose', k: 'sphere', s: [0.08], p: [0.45, 2.3, -1.25], c: '#8a8f94' },
      { part: 'wire', k: 'tube', s: [0.05], p: [-0.5, 1.9, -0.9], to: [-0.5, 1.9, -1.1], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [-0.5, 1.9, -1.1], to: [-0.55, 0.05, -1.35], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [-0.55, 0.05, -1.35], to: [-0.9, 0.05, -1.7], c: '#2a2a2a' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [-1.02, 0.16, -1.82], r: [0, 45, 0], c: '#f4f1ea' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [-1.18, 0.12, -1.98], r: [0, 45, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'fridge3d',
    label: 'Fridge',
    group: 'Home',
    parts: { door: 'door', freezer: 'freezer', handle: 'handle', magnet: 'magnet', picture: 'picture', grille: 'grille', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'body', k: 'box', s: [1.6, 3.35, 1.4], p: [0, 1.78, 0], c: '#dfe3e6' },
      { part: 'body', k: 'box', s: [1.5, 0.1, 1.3], p: [0, 0.05, 0], c: '#5a5a5a' },
      { part: 'freezer', k: 'rbox', s: [1.6, 1.0, 0.12, 0.04], p: [0, 2.93, 0.76], c: '#c9dbe6' },
      { part: 'door', k: 'rbox', s: [1.6, 2.25, 0.12, 0.04], p: [0, 1.25, 0.76], c: '#f2f4f5' },
      { part: 'handle', k: 'rbox', s: [0.12, 0.6, 0.1, 0.04], p: [-0.62, 2.7, 0.88], c: '#7d868e', f: 'metal' },
      { part: 'handle', k: 'rbox', s: [0.12, 0.9, 0.1, 0.04], p: [-0.62, 1.85, 0.88], c: '#7d868e', f: 'metal' },
      { part: 'magnet', k: 'sphere', s: [0.12], p: [0.45, 2.1, 0.83], sc: [1, 1, 0.5], c: '#d8574a', f: 'shiny' },
      { part: 'magnet', k: 'rbox', s: [0.22, 0.22, 0.06, 0.04], p: [0.1, 0.75, 0.85], c: '#e8c24a', f: 'shiny' },
      { part: 'magnet', k: 'sphere', s: [0.12], p: [0.5, 3.05, 0.83], sc: [1, 1, 0.5], c: '#5a9a6a', f: 'shiny' },
      { part: 'picture', k: 'plane', s: [0.7, 0.55], p: [0.25, 1.65, 0.825], r: [0, 0, -4], c: '#fffdf6', f: 'matte' },
      { part: 'picture', k: 'disc', s: [0.1], p: [0.43, 1.78, 0.83], c: '#f0b23a' },
      { part: 'picture', k: 'box', s: [0.6, 0.12, 0.01], p: [0.25, 1.46, 0.83], r: [0, 0, -4], c: '#7aa65a' },
      { part: 'picture', k: 'prism', s: [0.3, 0.2, 0.01], p: [0.05, 1.6, 0.83], c: '#c8524a' },
      { part: 'picture', k: 'box', s: [0.24, 0.2, 0.01], p: [0.05, 1.5, 0.832], c: '#5f86b0' },
      { part: 'grille', k: 'box', s: [1.3, 2.6, 0.03], p: [0, 1.75, -0.72], c: '#3a3d42' },
      { part: 'grille', k: 'tube', s: [0.04], p: [-0.55, 0.6, -0.77], to: [-0.55, 2.9, -0.77], c: '#1f2124', mx: true },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 0.8, -0.78], to: [0.6, 0.8, -0.78], c: '#6a6e74' },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 1.2, -0.78], to: [0.6, 1.2, -0.78], c: '#6a6e74' },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 1.6, -0.78], to: [0.6, 1.6, -0.78], c: '#6a6e74' },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 2.0, -0.78], to: [0.6, 2.0, -0.78], c: '#6a6e74' },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 2.4, -0.78], to: [0.6, 2.4, -0.78], c: '#6a6e74' },
      { part: 'grille', k: 'tube', s: [0.03], p: [-0.6, 2.8, -0.78], to: [0.6, 2.8, -0.78], c: '#6a6e74' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.6, 0.4, -0.7], to: [0.6, 0.4, -1.1], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.6, 0.4, -1.1], to: [0.7, 0.05, -1.5], c: '#2a2a2a' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.7, 0.05, -1.5], to: [1.0, 0.05, -1.8], c: '#2a2a2a' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [1.12, 0.16, -1.92], r: [0, -45, 0], c: '#f4f1ea' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [1.28, 0.12, -2.08], r: [0, -45, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'cooker3d',
    label: 'Cooker',
    group: 'Home',
    parts: { hob: 'hob', knob: 'knob', door: 'oven door', window: 'window', handle: 'handle', pan: 'pan', vent: 'vent', plug: 'plug' },
    shapes: [
      { part: 'body', k: 'box', s: [2.2, 2.6, 1.8], p: [0, 1.3, 0], c: '#e8e4dc' },
      { part: 'body', k: 'box', s: [2.1, 0.06, 1.7], p: [0, 2.63, 0], c: '#2e3034', f: 'shiny' },
      { part: 'body', k: 'box', s: [2.2, 0.55, 0.16], p: [0, 2.9, -0.82], c: '#d4cfc5' },
      { part: 'body', k: 'box', s: [1.9, 0.42, 0.04], p: [0, 0.3, 0.91], c: '#d4cfc5' },
      { part: 'hob', k: 'cyl', s: [0.32, 0.32, 0.05], p: [-0.5, 2.68, 0.4], c: '#c8524a', f: 'matte' },
      { part: 'hob', k: 'cyl', s: [0.32, 0.32, 0.05], p: [0.5, 2.68, -0.35], c: '#c8524a', f: 'matte', mx: true },
      { part: 'hob', k: 'cyl', s: [0.2, 0.2, 0.06], p: [-0.5, 2.69, 0.4], c: '#5a5d62' },
      { part: 'hob', k: 'cyl', s: [0.2, 0.2, 0.06], p: [0.5, 2.69, -0.35], c: '#5a5d62', mx: true },
      { part: 'knob', k: 'cyl', s: [0.14, 0.14, 0.12], p: [0.3, 2.35, 0.94], r: [90, 0, 0], c: '#3a3d42', mx: true },
      { part: 'knob', k: 'cyl', s: [0.14, 0.14, 0.12], p: [0.8, 2.35, 0.94], r: [90, 0, 0], c: '#3a3d42', mx: true },
      { part: 'door', k: 'rbox', s: [1.9, 1.55, 0.08, 0.04], p: [0, 1.32, 0.93], c: '#d4cfc5' },
      { part: 'window', k: 'box', s: [1.3, 0.8, 0.02], p: [0, 1.22, 0.975], c: '#2f3a44', f: 'glass' },
      { part: 'handle', k: 'tube', s: [0.06], p: [-0.75, 1.95, 1.08], to: [0.75, 1.95, 1.08], c: '#9aa3ab', f: 'metal' },
      { part: 'handle', k: 'box', s: [0.08, 0.08, 0.12], p: [0.7, 1.95, 1.02], c: '#9aa3ab', f: 'metal', mx: true },
      { part: 'pan', k: 'cyl', s: [0.42, 0.38, 0.3], p: [0.5, 2.86, 0.4], c: '#4a6f8a', f: 'shiny' },
      { part: 'pan', k: 'tube', s: [0.06], p: [0.85, 2.92, 0.4], to: [1.35, 2.95, 0.4], c: '#2a2a2a' },
      { part: 'vent', k: 'box', s: [1.4, 0.08, 0.04], p: [0, 2.2, -0.91], c: '#4a4d52' },
      { part: 'vent', k: 'box', s: [1.4, 0.08, 0.04], p: [0, 2.0, -0.91], c: '#4a4d52' },
      { part: 'vent', k: 'box', s: [1.4, 0.08, 0.04], p: [0, 1.8, -0.91], c: '#4a4d52' },
      { part: 'vent', k: 'box', s: [1.4, 0.08, 0.04], p: [0, 1.6, -0.91], c: '#4a4d52' },
      { part: 'plug', k: 'tube', s: [0.05], p: [-0.6, 0.6, -0.9], to: [-0.6, 0.6, -1.15], c: '#2a2a2a' },
      { part: 'plug', k: 'tube', s: [0.05], p: [-0.6, 0.6, -1.15], to: [-0.7, 0.05, -1.5], c: '#2a2a2a' },
      { part: 'plug', k: 'tube', s: [0.05], p: [-0.7, 0.05, -1.5], to: [-1.0, 0.05, -1.8], c: '#2a2a2a' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [-1.12, 0.16, -1.92], r: [0, 45, 0], c: '#f4f1ea' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [-1.28, 0.12, -2.08], r: [0, 45, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
  {
    id: 'bath3d',
    label: 'Bath',
    group: 'Home',
    parts: { tap: 'tap', plughole: 'plughole', plug: 'plug', foot: 'foot', duck: 'duck', towel: 'towel', soap: 'soap' },
    shapes: [
      { part: 'tub', k: 'box', s: [2.8, 0.12, 1.2], p: [0, 0.79, 0], c: '#f7f5f0' },
      { part: 'tub', k: 'rbox', s: [3.0, 0.85, 0.16, 0.05], p: [0, 0.775, 0.66], c: '#f7f5f0', mz: true },
      { part: 'tub', k: 'rbox', s: [0.16, 0.85, 1.48, 0.05], p: [1.42, 0.775, 0], c: '#f7f5f0', mx: true },
      { part: 'tub', k: 'box', s: [2.7, 0.7, 0.02], p: [0, 0.76, 0.75], c: '#6f9c8f', mz: true },
      { part: 'tub', k: 'box', s: [0.02, 0.7, 1.2], p: [1.51, 0.76, 0], c: '#6f9c8f', mx: true },
      { part: 'foot', k: 'sphere', s: [0.16], p: [1.2, 0.2, 0.5], sc: [1, 1.3, 1], c: '#c9a24a', f: 'metal', mx: true, mz: true },
      { part: 'plughole', k: 'disc', s: [0.18], p: [1.0, 0.856, 0], r: [-90, 0, 0], c: '#2a2a2a' },
      { part: 'plughole', k: 'torus', s: [0.18, 0.03], p: [1.0, 0.856, 0], r: [90, 0, 0], c: '#9aa3ab', f: 'metal' },
      { part: 'plug', k: 'cyl', s: [0.16, 0.13, 0.09], p: [0.6, 0.895, 0.3], c: '#2a2a2a' },
      { part: 'plug', k: 'tube', s: [0.025], p: [0.6, 0.94, 0.3], to: [0.75, 1.22, 0.6], c: '#9aa3ab', f: 'metal' },
      { part: 'tap', k: 'cyl', s: [0.07, 0.07, 0.35], p: [1.4, 1.37, 0.3], c: '#b9bec2', f: 'metal', mz: true },
      { part: 'tap', k: 'tube', s: [0.06], p: [1.4, 1.53, 0.3], to: [1.15, 1.53, 0.3], c: '#b9bec2', f: 'metal', mz: true },
      { part: 'tap', k: 'tube', s: [0.05], p: [1.15, 1.53, 0.3], to: [1.15, 1.4, 0.3], c: '#b9bec2', f: 'metal', mz: true },
      { part: 'tap', k: 'box', s: [0.3, 0.06, 0.06], p: [1.4, 1.57, 0.3], r: [0, 45, 0], c: '#c8524a' },
      { part: 'tap', k: 'box', s: [0.3, 0.06, 0.06], p: [1.4, 1.57, -0.3], r: [0, 45, 0], c: '#4f86b0' },
      { part: 'duck', k: 'sphere', s: [0.24], p: [-0.4, 1.04, 0], sc: [1.3, 0.85, 1], c: '#f2c94c', f: 'shiny' },
      { part: 'duck', k: 'sphere', s: [0.16], p: [-0.16, 1.3, 0], c: '#f2c94c', f: 'shiny' },
      { part: 'duck', k: 'cone', s: [0.07, 0.16], p: [0.04, 1.28, 0], r: [0, 0, -90], c: '#e08a3a' },
      { part: 'towel', k: 'rbox', s: [0.9, 0.12, 0.3, 0.03], p: [-0.5, 1.25, -0.66], c: '#c86b4e', f: 'soft' },
      { part: 'towel', k: 'rbox', s: [0.9, 0.75, 0.06, 0.03], p: [-0.5, 0.9, -0.8], c: '#c86b4e', f: 'soft' },
      { part: 'soap', k: 'rbox', s: [0.4, 0.06, 0.3, 0.02], p: [0.5, 1.24, -0.68], c: '#b9bec2', f: 'metal' },
      { part: 'soap', k: 'rbox', s: [0.3, 0.14, 0.2, 0.06], p: [0.5, 1.34, -0.68], c: '#b9a3d6', f: 'shiny' },
    ],
  },
  {
    id: 'toilet3d',
    label: 'Toilet',
    group: 'Home',
    parts: { lid: 'lid', seat: 'seat', bowl: 'bowl', cistern: 'cistern', button: 'flush button', pipe: 'pipe', roll: 'toilet roll', brush: 'brush' },
    shapes: [
      { part: 'bowl', k: 'cyl', s: [0.45, 0.55, 0.8], p: [0, 0.4, 0.05], c: '#f4f3ef', f: 'shiny' },
      { part: 'bowl', k: 'cyl', s: [0.75, 0.5, 0.42], p: [0, 0.98, 0.2], sc: [1, 1, 1.25], c: '#f4f3ef', f: 'shiny' },
      { part: 'seat', k: 'torus', s: [0.6, 0.09], p: [0, 1.22, 0.22], r: [90, 0, 0], sc: [1, 1.25, 1], c: '#a8c3d4', f: 'shiny' },
      { part: 'lid', k: 'cyl', s: [0.68, 0.68, 0.07], p: [0, 1.85, -0.42], r: [75, 0, 0], sc: [1, 1, 1.2], c: '#a8c3d4', f: 'shiny' },
      { part: 'cistern', k: 'rbox', s: [1.3, 1.1, 0.45, 0.06], p: [0, 1.75, -0.85], c: '#f4f3ef', f: 'shiny' },
      { part: 'bowl', k: 'box', s: [0.6, 0.4, 0.4], p: [0, 1.1, -0.7], c: '#f4f3ef', f: 'shiny' },
      { part: 'button', k: 'cyl', s: [0.16, 0.16, 0.06], p: [0, 2.33, -0.85], c: '#9aa3ab', f: 'metal' },
      { part: 'pipe', k: 'tube', s: [0.07], p: [0.4, 1.4, -1.05], to: [0.4, 1.4, -1.4], c: '#b9bec2', f: 'metal' },
      { part: 'pipe', k: 'tube', s: [0.07], p: [0.4, 1.4, -1.4], to: [0.4, 0.0, -1.4], c: '#b9bec2', f: 'metal' },
      { part: 'pipe', k: 'sphere', s: [0.1], p: [0.4, 1.4, -1.4], c: '#9aa3ab', f: 'metal' },
      { part: 'roll', k: 'cyl', s: [0.25, 0.25, 0.36], p: [-1.25, 1.05, 0], r: [0, 0, 90], c: '#fbfaf6', f: 'soft' },
      { part: 'roll', k: 'tube', s: [0.04], p: [-1.25, 0.0, 0], to: [-1.25, 1.05, 0], c: '#9aa3ab', f: 'metal' },
      { part: 'roll', k: 'cyl', s: [0.25, 0.25, 0.04], p: [-1.25, 0.02, 0], c: '#9aa3ab', f: 'metal' },
      { part: 'brush', k: 'cyl', s: [0.2, 0.18, 0.45], p: [1.0, 0.225, -0.9], c: '#7aa69a' },
      { part: 'brush', k: 'tube', s: [0.04], p: [1.0, 0.4, -0.9], to: [1.05, 1.1, -0.9], c: '#7aa69a' },
    ],
  },
  {
    id: 'tv3d',
    label: 'Television',
    group: 'Home',
    parts: { screen: 'screen', button: 'button', stand: 'stand', speaker: 'speaker', remote: 'remote', vent: 'vent', wire: 'wire', plug: 'plug' },
    shapes: [
      { part: 'frame', k: 'rbox', s: [3.2, 2.0, 0.12, 0.04], p: [0, 1.6, 0], c: '#26282c' },
      { part: 'frame', k: 'rbox', s: [2.6, 1.5, 0.35, 0.08], p: [0, 1.6, -0.22], c: '#3a3d42' },
      { part: 'screen', k: 'plane', s: [3.0, 1.65], p: [0, 1.7, 0.065], c: '#4f84b0', f: 'glow' },
      { part: 'screen', k: 'plane', s: [3.0, 0.5], p: [0, 1.12, 0.067], c: '#6aa56a', f: 'glow' },
      { part: 'button', k: 'rbox', s: [0.22, 0.13, 0.06, 0.02], p: [1.3, 0.72, 0.07], c: '#c8524a' },
      { part: 'stand', k: 'box', s: [0.35, 0.6, 0.2], p: [0, 0.38, -0.2], c: '#5a5d62', f: 'metal' },
      { part: 'stand', k: 'rbox', s: [1.4, 0.1, 0.8, 0.04], p: [0, 0.05, -0.15], c: '#5a5d62', f: 'metal' },
      { part: 'speaker', k: 'rbox', s: [2.2, 0.24, 0.3, 0.06], p: [0, 0.12, 0.65], c: '#6b6f75', f: 'matte' },
      { part: 'speaker', k: 'box', s: [2.0, 0.14, 0.02], p: [0, 0.12, 0.805], c: '#3a3d42', f: 'matte' },
      { part: 'remote', k: 'rbox', s: [0.28, 0.1, 0.75, 0.04], p: [1.4, 0.05, 1.1], r: [0, -20, 0], c: '#2a2a2a' },
      { part: 'remote', k: 'cyl', s: [0.05, 0.05, 0.04], p: [1.48, 0.11, 0.86], c: '#c8524a' },
      { part: 'remote', k: 'box', s: [0.16, 0.03, 0.25], p: [1.37, 0.11, 1.15], r: [0, -20, 0], c: '#9aa3ab' },
      { part: 'vent', k: 'box', s: [1.8, 0.08, 0.04], p: [0, 2.0, -0.41], c: '#1f2124' },
      { part: 'vent', k: 'box', s: [1.8, 0.08, 0.04], p: [0, 1.82, -0.41], c: '#1f2124' },
      { part: 'vent', k: 'box', s: [1.8, 0.08, 0.04], p: [0, 1.64, -0.41], c: '#1f2124' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.8, 1.2, -0.4], to: [0.8, 1.2, -0.6], c: '#c9ccd0' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.8, 1.2, -0.6], to: [0.9, 0.05, -0.9], c: '#c9ccd0' },
      { part: 'wire', k: 'tube', s: [0.05], p: [0.9, 0.05, -0.9], to: [1.2, 0.05, -1.3], c: '#c9ccd0' },
      { part: 'plug', k: 'rbox', s: [0.4, 0.32, 0.28, 0.05], p: [1.3, 0.16, -1.45], r: [0, -35, 0], c: '#f4f1ea' },
      { part: 'plug', k: 'box', s: [0.05, 0.12, 0.2], p: [1.42, 0.12, -1.64], r: [0, -35, 0], c: '#c9a24a', f: 'metal' },
    ],
  },
];
